
import { component } from '@/helpers/vueTyped';
import Drawer from '@/components/Drawer/Drawer.vue';
import BackgroundSwitcher from '@/components/SharedViews/Background/BackgroundSwitcher.vue';
import store, { dispatch } from '@/store';

export default component()({
  name: 'AppDrawer',

  computed: {
    blurred(): boolean { return store.state.mainBlurred; },
    drawerOpen(): boolean { return store.state.drawerOpen; },
  },

  methods: {
    closeDrawer() {
      dispatch('setDrawerOpenState', [false]);
    },
  },

  beforeRouteLeave(to, from, next) {
    dispatch('pushNavigationContext');
    next();
  },

  activated() {
    const context = store.state.navigationContext;

    if (context?.activeElement) {
      context.activeElement[0].focus();
    }
  },

  render() {
    return (
      <div class={['drawer-main-div', this.blurred && 'blurred']}>
        <Drawer />
        <main
          onFocusin={this.closeDrawer}
          class={[ 'content', this.drawerOpen && 'drawer-open' ]}
        >
          <router-view class='view'/>
        </main>
        <BackgroundSwitcher />
      </div>
    );
  },
});


// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7b6e4b09/AppDrawer.vue" });